import React from "react";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";
import "./Cursos.css";

const cursos = [
  { titulo: "Produtos e serviços Mr.Saizen", img: "/assets/cursos/curso1.JPG", link: "https://saizensquad.com.br" },
  { titulo: "High Low cursos", img: "/assets/cursos/curso2.jpg", link: "https://wa.me/5511978645958?text=Quero%20iniciar%20a%20minha%20consultoria" }
];

const Cursos = () => {
  return (
    <>
      <Header2 />

      <main className="gym">
        <section className="hero">
          <div
            className="hero__bg"
            style={{ backgroundImage: `url("/assets/cursos/fundo.jpg")` }}
          />
          <div className="hero__overlay" />
          <div className="hero__content container">
            <h1 className="hero__title">PRODUTOS DIGITAIS</h1>
            <p className="hero__subtitle">
              Conhecimento e prática reunidos para você evoluir no treino e no estilo de vida fitness.
            </p>
          </div>
        </section>

        <section className="cursos-full-bleed" aria-label="Cursos digitais — catálogo">
          <div className="cursos-grid">
            {cursos.map((c, i) => (
              <a
                key={i}
                href={c.link}
                className="curso-card"
                aria-label={`Abrir ${c.titulo}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div
                  className="curso-media"
                  style={{ backgroundImage: `url(${c.img})` }}
                />
                <div className="curso-body">
                  <div className="curso-meta">
                    <h3 className="curso-title">{c.titulo}</h3>
                    <p className="curso-text">{c.texto}</p>
                  </div>

                  <div className="curso-cta">
                    <span className="btn btn--primary">Ver produto</span>
                  </div>
                </div>

                <span className="curso-accent" aria-hidden="true" />
              </a>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Cursos;
